import { render } from "./BModal.vue?vue&type=template&id=023e71eb"
import script from "./BModal.vue?vue&type=script&lang=js"
export * from "./BModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__